import React from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { useLocalSelector } from '@app/services/hooks/useRedux';

import { useOrdersExport } from '../../hooks';
import { ALL_TAB, IOrdersFilters, OrdersTab } from '../../interfaces';

interface IProps {
  tab: OrdersTab;
  filters: IOrdersFilters;
}

export const ExportButton: React.FC<IProps> = ({ tab, filters }) => {
  const { token } = theme.useToken();
  const ordersT = useTranslation(NSKeys.counterpartyOrders);
  const canExport = useLocalSelector(
    (state) => state.currentSession.ordersContext?.scope?.$permissions?.export_counterparty_orders
  );
  const { mutate, status } = useOrdersExport();

  if (!canExport) {
    return null;
  }

  return (
    <Tooltip placement="bottomLeft" title={ordersT.t('export')}>
      <Button
        icon={<DownloadOutlined style={{ color: token.colorPrimary }} />}
        loading={status === 'loading'}
        onClick={() => mutate({ ...filters, module: tab === ALL_TAB ? undefined : tab })}
      />
    </Tooltip>
  );
};
